import { ReactNode } from 'react';
import LoadingFallback from '../shared/LoadingFallback';

export interface CardProps {
  title?: string;
  titleLoading?: boolean;
  className?: string;
  children: ReactNode | ReactNode[];
}

export function Card({
  title,
  titleLoading,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={`bg-paper py-3 px-4 rounded shadow-md xl:py-4 xl:px-5 dark:text-white ${className}`}
      {...rest}
    >
      {title && (
        <LoadingFallback isLoading={titleLoading} skeletonClasses="h-10 w-1/4">
          <h2 className="text-2xl font-medium xl:text-3xl">{title}</h2>
        </LoadingFallback>
      )}
      {children}
    </div>
  );
}
